var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgInfo(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 22 22' }, props),
        React.createElement("g", { fillRule: 'evenodd', transform: 'translate(1 1.5)' },
            React.createElement("circle", { cx: 10, cy: 9.5, r: 9.5, stroke: '#FFF', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 1.5 }),
            React.createElement("path", { fill: '#FFF', fillRule: 'nonzero', d: 'M10.175 6.102c.286 0 .518-.078.695-.234a.774.774 0 00.267-.611.814.814 0 00-.267-.624c-.177-.165-.409-.247-.695-.247s-.516.082-.689.247a.824.824 0 00-.26.624c0 .251.087.455.26.611.173.156.403.234.689.234zm.741 8.398V7.337H9.434V14.5z' }))));
}
export default SvgInfo;
//# sourceMappingURL=Info.js.map